import { buildIndex } from '../utils/indexing'
import { sort } from '../utils/arrays'
import * as API from '../utils/api'

const FETCH = 'FETCH_DATABASE_VIEWS'
const FETCH_SINGLE = 'FETCH_DATABASE_VIEW'
const CREATE = 'CREATE_DATABASE_VIEW'
const UPDATE = 'UPDATE_DATABASE_VIEW'
const DELETE = 'DELETE_DATABASE_VIEW'

const INITIAL_STATE = {
  views: {},
  loading: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${FETCH}_PENDING`: {
      return { ...state, loading: true }
    }

    case `${FETCH}_REJECTED`: {
      return { ...state, loading: false }
    }

    case `${FETCH}_FULFILLED`: {
      const views = buildIndex(action.payload.data, view => view.id)

      return {
        ...state,
        loading: false,
        views: {
          ...state.views,
          ...views,
        },
      }
    }

    case `${FETCH_SINGLE}_FULFILLED`: {
      const view = action.payload.data

      return {
        ...state,
        views: {
          ...state.views,
          [view.id]: view,
        },
      }
    }

    case `${CREATE}_FULFILLED`: {
      const view = action.payload.data

      return {
        ...state,
        views: {
          ...state.views,
          [view.id]: view,
        },
      }
    }

    case `${DELETE}_FULFILLED`: {
      const { viewId } = action.meta
      const views = { ...state.view }

      delete views[viewId]

      return {
        ...state,
        views,
      }
    }

    default:
      return state
  }
}

// Actions

export const fetchViews = organizationId => ({
  type: FETCH,
  payload: API.fetchViews(organizationId),
})

export const fetchView = viewId => ({
  type: FETCH_SINGLE,
  payload: API.fetchView(viewId),
})

export const createView = (organizationId, view) => ({
  type: CREATE,
  payload: API.createView(organizationId, view),
})

export const updateView = (viewId, view) => ({
  type: UPDATE,
  payload: API.updateView(viewId, view),
})

export const deleteView = viewId => ({
  type: DELETE,
  meta: { viewId },
  payload: API.deleteView(viewId),
})

// Selectors

export const getViews = organizationId => state => {
  let views = Object.values(state.views.views).filter(
    v => v.OrganizationId === organizationId
  )

  return sort(views, view => view.name)
}

export const getView = viewId => state => {
  return state.views.views[viewId]
}

export const getLoading = state => {
  return state.views.loading
}

export const getViewLink = (orgId, databaseId, table, id) => state => {
  let view = getViews(orgId)(state).filter(
    view =>
      view.type === 'database' &&
      view.body.databaseId === databaseId &&
      view.body.table === table
  )[0]

  if (view) {
    return `/databases/views/${view.id}/records/${id}`
  }
}
